var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHikingAreaMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2054_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.9736 9 9.40816V40.5918C9 43.0264 10.9736 45 13.4082 45H25.1509L27.0911 48.3605C27.9395 49.8299 30.0603 49.8299 30.9087 48.3605L32.8489 45H44.5918C47.0264 45 49 43.0264 49 40.5918V9.40816C49 6.9736 47.0264 5 44.5918 5H13.4082Z",
    fill: "#FF7700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 39.6667L26.4333 18.9333C26.5666 18.2889 26.8666 17.8053 27.3333 17.4827C27.8 17.16 28.2889 16.9991 28.8 17C29.3111 17.0009 29.7835 17.112 30.2173 17.3333C30.6511 17.5547 31.0009 17.888 31.2666 18.3333L32.6 20.4667C33 21.1111 33.5169 21.6947 34.1506 22.2173C34.7844 22.74 35.512 23.1231 36.3333 23.3667V21H38.3333V39.6667H36.3333V26.1333C35.2666 25.8889 34.2777 25.5 33.3666 24.9667C32.4555 24.4333 31.6666 23.7778 31 23L30.2 27L33 29.6667V39.6667H30.3333V31.6667L27.5333 29L25.1333 39.6667H22.3333ZM22.9 26.5L20.0666 25.9667C19.7111 25.9 19.4333 25.7164 19.2333 25.416C19.0333 25.1155 18.9666 24.7769 19.0333 24.4L20.0333 19.1667C20.1666 18.4555 20.5444 17.8942 21.1666 17.4827C21.7889 17.0711 22.4555 16.9324 23.1666 17.0667L24.7 17.3667L22.9 26.5ZM31 16.3333C30.2666 16.3333 29.6391 16.0724 29.1173 15.5507C28.5955 15.0289 28.3342 14.4009 28.3333 13.6667C28.3324 12.9324 28.5937 12.3049 29.1173 11.784C29.6409 11.2631 30.2684 11.0018 31 11C31.7315 10.9982 32.3595 11.2595 32.884 11.784C33.4084 12.3084 33.6693 12.936 33.6666 13.6667C33.664 14.3973 33.4031 15.0253 32.884 15.5507C32.3649 16.076 31.7369 16.3369 31 16.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2054_1137",
    x: 0.183673,
    y: 0.591836,
    width: 57.6327,
    height: 64.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2054_1137"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2054_1137",
    result: "effect2_dropShadow_2054_1137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2054_1137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHikingAreaMarker);
export default __webpack_public_path__ + "static/media/hiking_area_marker.b77f5b9437eb6df1ffb250c56a1f719a.svg";
export { ForwardRef as ReactComponent };